import React from 'react';
import './index.scss';
import { useLocalization } from '../../hooks/localization';

type OnboardingModalProps = {
    isOpen: boolean;
    onClose: () => void;
    hideCredentials?: boolean;
    customTitle?: string;
    customDescription?: string;
    isAlarmMode?: boolean;
    onboardingList: {
        username: string;
        password: string;
        alarm_password: string;
        show_onboarding_message: boolean;
    };
};

export const OnboardingModal: React.FC<OnboardingModalProps> = ({
    isOpen,
    onClose,
    hideCredentials = false,
    customTitle,
    customDescription,
    isAlarmMode = false,
    onboardingList
}) => {
    const { t } = useLocalization();

    if (!isOpen) return null;

    return (
        <div className="onboarding-modal-overlay">
            <button className="onboarding-modal-close" onClick={onClose}>&times;</button>
                <div className="onboarding-modal-content">
                    <div className="onboarding-modal-section-overflow">
                        <span className="onboarding-modal-title">{customTitle}</span>
                        {customDescription && (
                            <span className="onboarding-modal-description">{customDescription}</span>
                        )}
                        {!isAlarmMode && (
                            <>
                                <span className="onboarding-modal-title">{t('alarm_page.alarm_active')}</span>
                                <span>{t('alarm_page.alarm_active_status_description')}</span>
                                <span className="onboarding-modal-title">{t('alarm_page.at_home')}</span>
                                <span>{t('alarm_page.alarm_installed_at_home_description')}</span>
                                <span className="onboarding-modal-title">{t("alarm_page.at_outside")}</span>
                                <span>{t("alarm_page.alarm_installed_at_out_description")}</span>
                                <span className="onboarding-modal-title">{ t('alarm_page.passive')}</span>
                                <span>{t('alarm_page.alarm_passive_status_description')}</span>
                            </>
                        )}
                    </div>
                    {!hideCredentials && (onboardingList.show_onboarding_message ? (
                        <div className="onboarding-modal-section">
                            <p>{t("default_user")} : {onboardingList.username}</p> 
                            <p>{t("default_password")} : {onboardingList.password}</p> 
                            <p>{t("default_alarm_password")} : {onboardingList.alarm_password}</p> 
                        </div>
                    ) : (
                        <div className="onboarding-modal-section">
                        </div>
                    ))}
                </div>
        </div>
    );
}; 